import Vue from "vue";
import Router from "vue-router";

// Layouts
import PawsLayout from "@/layouts/paws/index";

// Views
import Base from "@/views/base/index";
import Start from "@/views/start/index";
import Verein from "@/views/verein/index";
import Impressum from "@/views/impressum/index";
import Privacy from "@/views/privacy/index";
import Events from "@/views/events/index";
import PuppyWeekend from "@/views/puppy-weekend/index";
import PuppyWeekendEvents from "@/views/puppy-weekend/events/index";
import PuppyWeekendNews from "@/views/puppy-weekend/news/index";
import PuppyWeekendTickets from "@/views/puppy-weekend/ticket/index";
import PuppyWeekendPartner from "@/views/puppy-weekend/partner/index";
import DevView from "@/views/dev";

import FormVerification from "@/components/signup-form/form-submit/index";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    document.documentElement.scrollTop = 0;
  },
  routes: [
    {
      path: "/",
      component: Base,
      children: [
        {
          path: "/",
          redirect: "/start",
        },
        {
          path: "start",
          name: "start",
          component: Start,
        },
        {
          path: "verein",
          name: "about-us",
          component: Verein,
        },
        {
          path: "events",
          name: "events",
          component: Events,
        },
        {
          path: "events/calendar",
          name: "event-calendar",
          component: Events,
        },
        {
          path: "events/subwoofer",
          name: "subwoofer",
          component: Events,
        },
        {
          path: "events/all-pawz",
          name: "all-pawz",
          component: Events,
        },
        {
          path: "events/csd-munich-2025",
          name: "csd-munich-2025",
          component: Events,
        },
        {
          path: "events/pets-friends-fetish",
          name: "pets-friends-fetish",
          component: Events,
        },
        {
          path: "impressum",
          name: "impressum",
          component: Impressum,
        },
        {
          path: "privacy",
          name: "privacy",
          component: Privacy,
        },
      ],
    },
    {
      path: "/events/pff2025",
      name: "puppy-weekend",
      component: PuppyWeekend,
      redirect: { name: "puppy-weekend.news" },
      children: [
        {
          path: "news",
          name: "puppy-weekend.news",
          alias: ["overview"],
          component: PuppyWeekendNews,
        },
        {
          path: "program",
          redirect: "program/0",
        },
        {
          path: "program/:eventKeyOrIndex",
          props: true,
          name: "puppy-weekend.program",
          component: PuppyWeekendEvents,
        },
        {
          path: "ticket",
          name: "puppy-weekend.ticket",
          component: PuppyWeekendTickets,
        },
        {
          path: "partner",
          name: "puppy-weekend.partner",
          component: PuppyWeekendPartner,
        },
      ],
    },

    // internal component routes
    {
      path: "/_form/form-transmit",
      component: FormVerification,
      props: (route) => ({
        formId: route.query.formId,
        transmissionPIN: route.query.pin,
        autoTransmit: true,
      }),
    },

    // dev routes
    {
      path: "/dev",
      component: DevView,
    },
  ],
});
